import { useTranslation } from 'react-i18next';

import Plans from '@/components/Plans';
import { usePlans } from '@/hooks/price';

function Payment() {
	const { t } = useTranslation();
	const plansData = usePlans();

	return (
		<div className="z-10 flex flex-col gap-10">
			<div className="flex flex-col items-center gap-5 text-center">
				<h3 className="whitespace-break-spaces font-title text-[32px] font-semibold leading-10 -tracking-[1px] lg:text-[40px] lg:font-bold lg:leading-[52px]">
					{t('unsubscribe.payment.title')}
				</h3>
				<p className="lg:max-w-[814px]">
					{t('unsubscribe.payment.subtitle')}
				</p>
			</div>
			<div className="relative">
				<div className="absolute left-0 right-0 top-[70rem] z-0 mx-auto hidden size-[294px] rounded-full bg-red blur-[142px] lg:block" />
				<Plans plansData={plansData} withCTA={false} />
			</div>
		</div>
	);
}

export default Payment;
